import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer, pricingRows } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-108" data-mp="2ar2ea9wnokl1">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-109" data-mp="2ohnxjzq0uwjg">
        <h2 className="mx-auto max-w-xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-110" data-mp="2jjw616tahcfs">
          Offre spéciale de lancement
        </h2>

        <div className="relative mx-auto mt-14 max-w-xl rounded-2xl bg-white px-6 pb-8 pt-10 ring-2 ring-blue-600 md:px-10 md:pb-10" data-id="element-111" data-mp="1vvv085nhwa42">
          <p className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-blue-600 px-5 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-112" data-mp="25shlgvjqh36m">
            Système complet
          </p>

          <dl className="divide-y divide-slate-200" data-id="element-113" data-mp="3h5jrwxs4ccd2">
            {pricingRows.map(row => <div key={row.label} className="flex items-start justify-between gap-6 py-4" data-id="element-114" data-mp="3c7s3weulhae5">
                <dt className="text-slate-900" data-id="element-115" data-mp="3vyx9k642cai7">{row.label}</dt>
                <dd className="shrink-0 font-extrabold text-blue-700" data-id="element-116" data-mp="4smcsm635vwo">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-6 py-4" data-id="element-117" data-mp="9ta5rddvkmtj">
              <dt className="text-sm font-bold uppercase tracking-wider text-slate-900" data-id="element-118" data-mp="erv4f8dhayfv">Valeur totale :</dt>
              <dd className="shrink-0 font-extrabold text-slate-500 line-through" data-id="element-119" data-mp="3d9qnqa7z32s6">{offer.totalValue}</dd>
            </div>
          </dl>

          <div className="mt-6 text-center" data-id="element-120" data-mp="3i8bp4cyynsi7">
            <p className="text-xs font-bold uppercase tracking-widest text-blue-600" data-id="element-121" data-mp="3n7es7rvdronj">Prix de lancement</p>
            <p className="mt-2 text-7xl font-extrabold leading-none tracking-tight text-blue-600 md:text-8xl" data-id="element-122" data-mp="3ryder96ypiz8">
              {offer.price}
            </p>
            <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-123" data-mp="2ugdbvnfybn2f">
              Prix habituel <span className="line-through" data-id="element-124" data-mp="2zfzp3wvs53b8">{offer.listPrice}</span>
            </p>
          </div>

          <div className="mt-8 border-t border-slate-200 pt-7" data-id="element-125" data-mp="2rfa2zhrwi1cp">
            <p className="text-center text-sm text-slate-600" data-id="element-126" data-mp="2mijpn27hdjuz">Paiement unique, accès à vie. Aucun abonnement.</p>
            <div className="mt-5" data-id="element-127" data-mp="315mr1jyxccnl">
              <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-128" data-mp="318qxyp3rxmhy">
                {offer.cta}
              </CtaButton>
            </div>
            <p className="mt-4 text-center text-sm text-slate-500" data-id="element-129" data-mp="28h7b8v7yxqb7">
              Accès immédiat · Paiement unique · Accès à vie · Garantie 7 jours satisfait ou remboursé
            </p>
          </div>
        </div>
      </div>
    </section>;
}